import React from 'react'
import { Button } from 'semantic-ui-react'
import * as Config from '../../../public/external-links'
import Accordion from '../../common/Accordion'

export const RequestForRecordsFooter = (props) => {
  return (
    <Accordion
      heading="Your template letter is now ready"
      expanded={props.show}
      onClick={() => props.setShow()}
    >
      <p>We suggest you save it to your device.</p>
      <p>
        This will create a Word document that you can review and edit before you
        send it to your employer.
      </p>
      <h3>Save to your device</h3>
      <Button className="ui is-primary button" onClick={props.handleDownload}>
        Download
      </Button>
      <p>
        The Fair Work Regulations 2009 require your employer to make a copy of
        the records available at the business premises within 3 business days,
        or post a copy to you within 14 days after receiving the request.
      </p>
      <p>
        If the records are not kept at the business premises, the employer must
        make the records available to you as soon as practicable after receiving
        the request.
      </p>
      <p>
        Your employer must (if you ask them) tell you where your employee
        records are kept.
      </p>
      <p>
        Once you have received your employee records, our{' '}
        <a
          target="_blank"
          href={Config.INTERACTIVE_TEMPLATE_PAY_CALCULATOR}
          rel="noreferrer"
          className="external-link"
        >
          {' '}
          Pay and Conditions Tool (PACT)
        </a>{' '}
        can help you to check whether you have received your correct
        entitlements.
      </p>
    </Accordion>
  )
}
